import(/* webpackMode: "eager" */ "/Users/prathamesh/Downloads/claude-transfer/locobuzz-website/app/platform/holistic-digital-care/page.js");
